module.exports = __webpack_public_path__ + "static/media/drinkIcon.f87c47c3.svg";